'use strict';

var React = require('react'),
    ReactRouter = require('react-router'),
    BS = require('react-bootstrap'),
    DocumentTitle = require('react-document-title'),
    cx = require('classnames'),
    CurrentUser = require('../../shared/CurrentUser'),
    Constants = require('../../constants'),
    _ = require('underscore'),
    UserLogin = require('../../models/UserLogin'),
    FluxBone = require('../../mixins/FluxBone'),
    Cmp = require('../../components'),
    Link = require('../../components/Link'),
    Validation = require('../../partials/validation'),
    Footer = require('./Footer'),
    URI = require('urijs'),
    $ = require('jquery');

var Login = React.createClass({displayName: "Login",
    mixins: [ReactRouter.Navigation, FluxBone.CollectionMixin('project', 'sync')],
    statics: {
        willTransitionTo: function(transition, params) {
            if (CurrentUser.isLoggedIn()) {
                transition.redirect(
                    'Dashboard',
                    {},
                    {
                        API: URI(transition.path).query(true).API
                    }
                );
            }
        },
        willTransitionFrom: function(transition, me, callback) {
            var path = transition.path,
                isPathForgotPassword = path.indexOf('/forgotpassword') === 0,
                isPathSignup = path.indexOf('/signup') === 0;

            if (me && !CurrentUser.isLoggedIn() && !isPathForgotPassword && !isPathSignup) {
                transition.cancel();
                if (me.goBack) {
                    me.goBack();
                }
            } else {
                callback();
            }
        }
    },

    contextTypes: {
        router: React.PropTypes.func
    },

    getDefaultProps: function() {
        return {
            model: new UserLogin(),
            project: undefined
        };
    },

    updateState: function() {
        return {
            error: undefined
        };
    },

    getInitialState: function() {
        return this.updateState();
    },

    componentWillReceiveProps: function() {
        this.setState(this.updateState());
    },

    componentWillMount: function() {
        this.props.model.clear();
    },

    render: function() {
        var me = this,
            props = me.props,
            project = props.project || props.builder,
            usernameIcon = React.createElement("i", {className: "fa fa-envelope fa-fw"}),
            passwordIcon = React.createElement("i", {className: "fa fa-lock fa-fw"}),
            projectName = project ? project.get('name') : '',
            title = props.title + ' - Login';

        return (
            React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: "col-sm-8 col-sm-offset-2"}, 
                            React.createElement("h1", {className: "text-center"}, "Agent Portal for ", React.createElement("span", {className: "blue-text"}, projectName)), 
                            React.createElement("p", {className: "font-larger"}, 
                                React.createElement("span", {className: "blue-text"}, projectName), " promotes and encourages the participation of real estate agents and brokers. The agent portal contains exclusive tools" + ' ' +
                                "and information to help agents/brokers market ", projectName, " to their buyers."
                            ), 
                            React.createElement("p", {className: "font-larger"}, 
                                "Log in to access exclusive tools and information."
                            ), 
                            React.createElement("hr", null), 
                            React.createElement("p", null, 
                                "The Agent Portal for ", React.createElement("span", {className: "blue-text"}, projectName), " is powered by New Construction Hub. You will need an New Construction Hub account to access. If" + ' ' +
                                "you do not have an account, use the button below to create one."
                            ), 
                            React.createElement("p", {className: "margin-bottom-20"}, 
                                "Need technical help? ", React.createElement("a", {href: "#", className: "font-bold", onClick: me.toggleHelp}, "Click Here"), "."
                            )
                        )
                    ), 
                    React.createElement("div", {className: "row"}, 
                        React.createElement("div", {className: "col-sm-6 col-sm-offset-3"}, 
                            React.createElement(BS.Panel, {className: "panel-split-header", header: React.createElement("h2", null, "Log into your New Construction Hub account.")}, 
                                React.createElement(Validation.Form, {horizontal: false, ref: "form", model: props.model, onSubmit: me.onSubmit, getMessage: me.getMessage, validateOnLoad: false, error: me.state.error}, 
                                    React.createElement(Validation.Input, {trigger: "onChange", addonBefore: usernameIcon, type: "text", placeholder: "Email Address", name: "username"}), 
                                    React.createElement(Validation.Input, {trigger: "onChange", addonBefore: passwordIcon, type: "password", placeholder: "Password", name: "password"}), 

                                    React.createElement("div", {className: "row"}, 
                                        React.createElement("div", {className: "col-xs-12"}, 
                                            React.createElement(Cmp.Button.Save, {className: "pull-right"}, "Login")
                                        )
                                    )
                                ), 

                                React.createElement("hr", null), 

                                React.createElement("p", {className: "text-left"}, "Forgot your password? ", React.createElement(Link, {to: "ForgotPassword"}, "CLICK HERE"), " to reset your password."), 
                                React.createElement("p", {className: "text-left"}, "Don't have a NewConstructionHub.com account? ", React.createElement(Link, {to: "Signup"}, "CLICK HERE"), " to create an account.")
                            ), 
                            React.createElement(Footer, {trackerId: "agent-toolbox-login"})
                        )
                    )
                )
            )
        );
    },

    onSubmit: function(e) {
        this.doLogin();
    },

    doLogin: function() {
        var me = this,
            state = me.state,
            props = me.props,
            project = me.props.project || me.props.builder;
        if (this.refs.form.isValid()) {
            props.model.login(this.refs.form.getValues()).then(function() {
                var type = CurrentUser.getType();
                if (type === 'Admin' || type === 'Agent') {
                    me.transitionTo.call(me, props.redirect || Constants.defaultRedirect[0], undefined, _.result(Constants, 'query'));
                } else {
                    CurrentUser.logout();
                    me.setState({
                        error: 'Only agents can access this resource.'
                    });
                }
            });
        }
    },

    getMessage: function(type, model_collection, response, options) {
        return 'Login Failed. Please try again.';
    },

    toggleHelp: function(e) {
        if (e && e.preventDefault) {
            e.preventDefault();
        }

        if (window.FreshWidget && $(FreshWidget.iframe()).is(':visible') && window.FreshWidget.hide) {
            FreshWidget.hide();
        } else if (window.FreshWidget && window.FreshWidget.show) {
            FreshWidget.show();
            $(FreshWidget.iframe()).attr('scrolling', 'no');
        }
    }
});
module.exports = Login;
